<div class="applied-jobs">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p class="loading-text">{{ 'pages.jobs.appliedJobs.loading' | transloco }}</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="error-container">
    <i class="fas fa-exclamation-circle error-icon"></i>
    <p class="error-text">{{ error }}</p>
    <button mat-button color="primary" (click)="loadAppliedJobs()">
      {{ 'common.retry' | transloco }}
    </button>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && !error && mappedJobs.length === 0" class="empty-state">
    <i class="fas fa-briefcase empty-icon"></i>
    <h3>{{ 'pages.jobs.appliedJobs.empty.title' | transloco }}</h3>
    <p>{{ 'pages.jobs.appliedJobs.empty.description' | transloco }}</p>
    <button mat-raised-button color="primary" routerLink="/">
      {{ 'pages.jobs.appliedJobs.empty.browseJobs' | transloco }}
    </button>
  </div>

  <!-- Applied Jobs List -->
  <div *ngIf="!isLoading && !error && mappedJobs.length > 0" class="applied-jobs-list">
    <div class="applied-jobs-header">
      <h2>{{ 'pages.jobs.appliedJobs.title' | transloco }}</h2>
      <div class="header-controls">
        <p class="jobs-count">
          {{ totalApplications }} {{ 'pages.jobs.appliedJobs.totalApplications' | transloco }}
        </p>
        <div class="limit-selector">
          <label for="applied-limit-select" class="limit-selector__label">
            {{ 'pages.jobs.appliedJobs.showJobs' | transloco }}:
          </label>
          <div class="limit-selector__wrap">
            <select
              id="applied-limit-select"
              class="limit-selector__select"
              [value]="selectedLimit"
              (change)="onLimitChange(+$any($event.target).value)">
              <option *ngFor="let opt of limitOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <i class="fas fa-chevron-down limit-selector__chevron" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="jobs-grid">
      <app-job-detail-card
        *ngFor="let job of mappedJobs"
        [job]="job"
        mode="applied"
        [jobDetailRoute]="job.localizedRoute"
        (saveJob)="onSaveJob($event)"
        (unsaveJob)="onUnsaveJob($event)">
      </app-job-detail-card>
    </div>

    <!-- Load More Button -->
    <app-load-more-button
      *ngIf="hasMoreJobs"
      [totalItems]="totalApplications"
      [shownItems]="mappedJobs.length"
      [remainingCount]="remainingCount"
      [isLoading]="isLoadingMore"
      (loadMore)="loadMore()">
    </app-load-more-button>
  </div>
</div>
